import React, { useEffect, useRef, useState, useMemo } from "react";
import Chart from "chart.js/auto";
import "chartjs-adapter-date-fns";

export default function ChartManager({
  chartData,
  selectedRegisters,
  timeRange,
}) {
  const isMobile = window.innerWidth < 768;
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const [fontSize, setFontSize] = useState(10);
  console.log(selectedRegisters);
  const REGISTER_CONFIG = [
    {
      key: "COMP_OIL_PRES",
      label: "Compressor Oil Pressure",
      color: "#d62728",
      yAxis: "y",
    },
    {
      key: "DISCHARGE_PRES",
      label: "Discharge Pressure",
      color: "#9467bd",
      yAxis: "y",
    },
    {
      key: "DISCHARGE_TEMP_FINAL",
      label: "Discharge Temperature",
      color: "#8c564b",
      yAxis: "y",
    },
    {
      key: "ENGINE_COOLANT_TEMP",
      label: "Engine Coolant Temp",
      color: "#e377c2",
      yAxis: "y",
    },
    {
      key: "ENGINE_HOURMETER",
      label: "Engine Hourmeter",
      color: "#7f7f7f",
      yAxis: "yHours",
    },
    {
      key: "ENGINE_SPEED",
      label: "Engine Speed",
      color: "#bcbd22",
      yAxis: "y",
    },
    {
      key: "FIELD_PRES",
      label: "Field Pressure",
      color: "#17becf",
      yAxis: "y",
    },
    {
      key: "FLOW_METER",
      label: "Main Flow Meter",
      color: "#393b79",
      yAxis: "y",
    },
    {
      key: "INTERSTAGE_PRES",
      label: "Interstage Pressure",
      color: "#637939",
      yAxis: "y",
    },
    {
      key: "SUCTION_PRES",
      label: "Suction Scrubber Pressure",
      color: "#8c6d31",
      yAxis: "y",
    },
    {
      key: "SYSTEM_VOTLS",
      label: "System Volts",
      color: "#843c39",
      yAxis: "y",
    },
    {
      key: "STATE",
      label: "State",
      color: "#803984ff",
      yAxis: "yHours",
    },
    {
      key: "FLOW_RATE_SP",
      label: "Flow Rate SP",
      color: "#398482ff",
      yAxis: "y",
    },
    {
      key: "ENGINE_OIL_TEMP",
      label: "Engine Oil Temp",
      color: "#843939ff",
      yAxis: "y",
    },
    {
      key: "ENGINE_OIL_PRES",
      label: "Engine Oil Press",
      color: "#d4ff00ff",
      yAxis: "y",
    },
    {
      key: "ENGINE_MANIFOLD_PRES",
      label: "Engine Manifold Pres",
      color: "#00ffd5ff",
      yAxis: "y",
    },
    {
      key: "DISCHARGE_2_TEMP",
      label: "2nd Stage Discharge Temp",
      color: "#ffa600ff",
      yAxis: "y",
    },
    {
      key: "AI10",
      label: "Main Motor Speed Ref",
      color: "#008cffff",
      yAxis: "y",
    },
    {
      key: "AI11",
      label: "Main Motor Amps",
      color: "#00ddffff",
      yAxis: "y",
    },
    {
      key: "AI12",
      label: "Cooler Motor Amps",
      color: "#0b9c32ff",
      yAxis: "y",
    },
    {
      key: "COMP_HOURMETER",
      label: "Comp Hourmeter",
      color: "#730b9cff",
      yAxis: "y",
    },
    {
      key: "TAILSHAFT_TEMP",
      label: "Tailshaft Temp",
      color: "#9c0b39ff",
      yAxis: "y",
    },
    {
      key: "AI7",
      label: "AI7",
      color: "#ae6c81ff",
      yAxis: "y",
    },
    {
      key: "AI8",
      label: "AI8",
      color: "#3e9934ff",
      yAxis: "y",
    },
    {
      key: "AI9",
      label: "AI9",
      color: "#345699ff",
      yAxis: "y",
    },
    {
      key: "SPN1",
      label: "SPN1",
      color: "#878f30ff",
      yAxis: "y",
    },
    {
      key: "SPN2",
      label: "SPN2",
      color: "#649ba3ff",
      yAxis: "y",
    },
    {
      key: "SPN3",
      label: "SPN3",
      color: "#8f3030ff",
      yAxis: "y",
    },
    {
      key: "SPN4",
      label: "SPN4",
      color: "#908ad0ff",
      yAxis: "y",
    },
    {
      key: "FMI1",
      label: "FMI1",
      color: "#00f96cff",
      yAxis: "y",
    },
    {
      key: "FMI2",
      label: "FMI2",
      color: "#8ad09eff",
      yAxis: "y",
    },
    {
      key: "FMI3",
      label: "FMI3",
      color: "#908ad0ff",
      yAxis: "y",
    },
    {
      key: "FMI4",
      label: "FMI4",
      color: "#8ad091ff",
      yAxis: "y",
    },
    {
      key: "CM1",
      label: "CM1",
      color: "#d0cf8aff",
      yAxis: "y",
    },
    {
      key: "CM2",
      label: "CM2",
      color: "#8ab2d0ff",
      yAxis: "y",
    },
    {
      key: "CM3",
      label: "CM3",
      color: "#d09f8aff",
      yAxis: "y",
    },
    {
      key: "CM4",
      label: "CM4",
      color: "#235424ff",
      yAxis: "y",
    },
    {
      key: "LAT",
      label: "LAT",
      color: "#20b5b8ff",
      yAxis: "y",
    },
    {
      key: "LON",
      label: "LON",
      color: "#46309fff",
      yAxis: "y",
    },
    {
      key: "SHUTDOWN_ENUM",
      label: "Shutdown Enum",
      color: "#2c869fff",
      yAxis: "y",
    },
  ];
  const HOUR_REGISTERS = new Set(["ENGINE_HOURMETER", "COMP_HOURMETER"]);

  // Responsive font size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) setFontSize(8);
      else if (window.innerWidth < 960) setFontSize(10);
      else setFontSize(12);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Initialize / update chart
  useEffect(() => {
    if (!chartRef.current) return;

    // Destroy previous chart
    if (chartInstanceRef.current) chartInstanceRef.current.destroy();

    const ctx = chartRef.current.getContext("2d");
    if (!ctx) return;

    const chart = new Chart(ctx, {
      type: "line",
      data: { labels: [], datasets: [] },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { intersect: false, mode: "index" },
        scales: {
          x: {
            type: "time",
            time: {
              tooltipFormat: "MM/dd/yyyy hh:mm a",
              displayFormats: {
                minute: "hh:mm a",
                hour: "MM/dd hh:mm a",
                day: "MM/dd/yyyy",
              },
            },
            ticks: {
              color: "white",
              maxRotation: 45,
              maxTicksLimit: window.innerWidth < 600 ? 4 : 8,
              font: {
                size: fontSize,
              },
            },
            title: {
              display: true,
              text: "Date & Time",
              color: "white",
              font: {
                size: fontSize + 2,
              },
            },
            grid: { color: "rgba(255,255,255,0.2)" },
          },
          // 🔹 Normal signals
          y: {
            type: "linear",
            position: "right",
            beginAtZero: true,
            ticks: { color: "white", font: { size: fontSize } },
            title: {
              display: true,
              text: "Pressure / Temp / Flow / Speed",
              color: "white",
              font: { size: fontSize + 2 },
            },
            grid: { color: "rgba(255,255,255,0.2)" },
          },
          yHours: {
            type: "linear",
            position: "left",
            beginAtZero: false, // ⬅️ important for large cumulative values
            ticks: {
              color: "white",
              font: { size: fontSize },
              callback: (value) => `${value} `, // nice UX
            },
            title: {
              display: true,
              text: "Hours",
              color: "white",
              font: { size: fontSize + 2 },
            },
            grid: { drawOnChartArea: false },
          },
        },
        plugins: {
          legend: {
            position: isMobile ? "bottom" : "right",
            labels: {
              color: "white",
              font: { size: fontSize },
              boxWidth: 12,
              padding: 12,
            },
          },
          title: {
            display: true,
            text: "Engine Data Time Series",
            color: "white",
            font: { size: fontSize + 4 },
          },
        },
      },
    });

    chartInstanceRef.current = chart;

    if (chartData && chartData.time) {
      const labels = chartData.time.map((t) => new Date(t * 1000));

      const datasets = REGISTER_CONFIG.filter((ds) =>
        selectedRegisters.includes(ds.key)
      ).map((ds) => ({
        label: ds.label,
        borderColor: ds.color,
        backgroundColor: ds.color,
        data: chartData[ds.key] || [],
        pointRadius: 1,

        // ✅ FORCE hourmeters onto their own axis
        yAxisID: HOUR_REGISTERS.has(ds.key) ? "yHours" : "y",
      }));

      chart.data.labels = labels;
      chart.data.datasets = datasets;
      chart.update();
    }

    return () => chart.destroy();
  }, [chartData, selectedRegisters, fontSize]);

  // Display info
  const displayInfo = useMemo(() => {
    if (!chartData || !chartData.time || chartData.time.length === 0)
      return null;
    return {
      count: chartData.time.length,
      start: new Date(chartData.time[0] * 1000).toLocaleString(),
      end: new Date(
        chartData.time[chartData.time.length - 1] * 1000
      ).toLocaleString(),
    };
  }, [chartData]);
  console.log("chartData keys:", Object.keys(chartData));
  return (
    <div className="w-full bg-slate-800 rounded-xl p-2 sm:p-3">
      {/* Chart Container */}
      <div
        className="
        relative w-full
        h-[50vh] sm:h-[45vh] lg:h-[60vh]
        bg-slate-800 rounded-md
      "
      >
        {!chartData || !chartData.time || chartData.time.length === 0 ? (
          <div className="w-full h-full flex items-center justify-center text-center px-3 text-slate-400 text-xs sm:text-sm font-medium">
            No chart data available for the last {timeRange.hours} hours
          </div>
        ) : (
          <canvas ref={chartRef} className="w-full h-full" />
        )}
      </div>

      {/* Footer Info */}
      {displayInfo && (
        <div
          className="
          flex flex-col sm:flex-row
          flex-wrap
          justify-between
          items-center sm:items-start
          gap-1 sm:gap-2
          text-white
          text-[10px] sm:text-xs
          mt-2
          border-t border-white/10
          pt-2
        "
        >
          <span className="text-center sm:text-left">
            Start: {displayInfo.start}
          </span>
          <span className="text-center">Points: {displayInfo.count}</span>
          <span className="text-center sm:text-right">
            End: {displayInfo.end}
          </span>
        </div>
      )}
    </div>
  );
}
